import React from 'react';
import { useAuth } from '../context/AuthContext';
import ViewAsBar from './ViewAsBar';

/**
 * The banner half of ViewAsBar, mounted above the top bar.
 *
 * ViewAsBar renders the picker when you are yourself and the banner when you
 * are previewing; the picker belongs in the top bar's controls and the banner
 * belongs across the whole width, so the two mount points ask for the one they
 * want and the other renders nothing.
 */
function ViewAsBanner() {
  const { user } = useAuth();
  if (!user?.viewAs) return null;
  return <ViewAsBar />;
}

export default ViewAsBanner;
